import { FormControl, Grid, TextField } from '@mui/material'
import React, { useEffect } from 'react'

import {
    CustomAutocomplete,
    LinearLoading
} from '../../../../../common'

export const TransferToCentral = ({ useFetchInit, readOnlyMode }) => {
    const {
        Forms,
        FetchData
    } = useFetchInit

    const { fetchCashierByCategory } = FetchData
    const { dataCashierByCategory, loadingFetchCashierByCategory } = fetchCashierByCategory

    const { FormScreen } = Forms
    const { formState, onInputNumberChange, onSelectSearchChange } = FormScreen

    useEffect(() => {
                
        fetchCashierByCategory.setParamsToSearch({
            idcategoria: 3, // CAJA CENTRAL
            currency_type: formState.currency_type // Según el tipo de moneda seleccionado (solo puede transferir a los mismos tipos)
        })
        fetchCashierByCategory.executeFetch()

    }, [formState.currency_type])

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="monto_solicitado"> * Monto a Trasladar</label>
                    <TextField
                        id='monto_solicitado'
                        name='monto_solicitado'
                        value={ formState.monto_solicitado_mask } 
                        onChange={ onInputNumberChange }
                        size='small'
                        placeholder='500.50, 100.00'
                        type='text'
                        variant={readOnlyMode? 'filled': 'outlined'}
                        hiddenLabel
                        InputProps={{
                            readOnly: readOnlyMode 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="idcaja_destino">* Caja Destino</label>
                    {(loadingFetchCashierByCategory)&&(<LinearLoading/>)}
                    <CustomAutocomplete 
                        customId="idcaja_destino"
                        customName="idcaja_destino"
                        customValue={formState.idcaja_destino}
                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja_destino', value: value.value }})}
                        customPlaceholder='Seleccionar opción'
                        customOptions={
                            dataCashierByCategory.map(({ idcaja, descripcion_corta, currency_type }) => ({
                                value: idcaja,
                                name: `${descripcion_corta} - ${currency_type}`
                            }))
                        }
                        customDisableClearable={true}
                        customDisabled={readOnlyMode}
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}
